export const updateUserProfile = (data) => ({
    type: "UserUpdate",
    payload: data,
})

export const userLoginStatus = (data) => ({
    type : "loginStatus",
    payload : data
})